import { MatIntegrationCard } from "@/components/Mat";
import Shimmer from "@/components/Shimmer";
import {
  H3,
  HeaderTextBlock,
  TypographyContainer,
} from "@/components/Typography";
import { useMatIntegrations } from "@/requests/hooks/mat";
import { faToolbox } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";

const MatListing = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const message = searchParams.get("message");
  const { t } = useTranslation();
  const {
    data: matIntegrationsData,
    isLoading: isMatIntegrationsLoading,
    refetch: refetchMatIntegrations,
  } = useMatIntegrations();

  useEffect(() => {
    if (message === "oauth_failure") {
      toast.error(t("integrations.matSettings.listing.oauthFailure"));
    }
    if (message === "oauth_forbidden") {
      toast.error(t("integrations.matSettings.listing.oauthForbidden"));
    }
    if (message) setSearchParams(undefined, { replace: true });
  }, [message]);

  const renderIntegrations = () => {
    if (isMatIntegrationsLoading) {
      return (
        <>
          <Shimmer height={353} />
          <Shimmer height={353} />
          <Shimmer height={353} />
        </>
      );
    }

    if (!matIntegrationsData?.length) {
      return (
        <div
          data-testid="mat-integrations-not-found"
          className="col-span-3 my-50 flex flex-col items-center justify-center gap-30">
          <FontAwesomeIcon
            fixedWidth
            icon={faToolbox}
            size="3x"
            className="text-primary"
          />
          <H3>{t("integrations.matSettings.listing.notFound")}</H3>
        </div>
      );
    }

    return matIntegrationsData?.map((matIntegration, index) => (
      <MatIntegrationCard
        key={index}
        matIntegration={matIntegration}
        refetchMatIntegrations={refetchMatIntegrations}
      />
    ));
  };

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          align="left"
          featureText={t("integrations.matSettings.listing.header.feature")}
          headingText={t("integrations.matSettings.listing.header.heading")}
        />
      </TypographyContainer>

      <div className="grid-rows-auto mt-50 grid grid-cols-1 gap-20 lg:grid-cols-2 xl:grid-cols-3">
        {renderIntegrations()}
      </div>
    </>
  );
};

export default MatListing;
